export type FileTypeBadge = {label: string; color: string};

const TYPE_BADGES: Array<{match: (mime: string) => boolean; badge: FileTypeBadge}> = [
  {match: (m) => m === "application/pdf", badge: {label: "PDF", color: "#c03a2b46"}},
  {match: (m) => m.includes("word"), badge: {label: "DOC", color: "#2c3e8f"}},
  {
    match: (m) => m.includes("spreadsheet") || m.includes("excel"),
    badge: {label: "XLS", color: "#1f7a4d46"},
  },
  {
    match: (m) => m.includes("presentation") || m.includes("powerpoint"),
    badge: {label: "PPT", color: "#c47b2b46"},
  },
];

const FALLBACK_BADGE: FileTypeBadge = {label: "FILE", color: "#6c757d46"};

export function getFileTypeBadge(mimeType: string): FileTypeBadge {
  return TYPE_BADGES.find((b) => b.match(mimeType))?.badge ?? FALLBACK_BADGE;
}

export function isImageMime(mimeType: string): boolean {
  return mimeType.startsWith("image/");
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} o`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} Ko`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}
